module.exports = __webpack_public_path__ + "static/media/itrim.5d882cf8.svg";